import { PastorImgKey } from '../imgs/pastorsImg';

interface CardData {
  name: string;
  img: PastorImgKey; 
}

interface PastorsRes { 
  title: string; 
  cardData: CardData[]; 
}

export const pastorsData: PastorsRes[] = [
  {
    title: '강도사',
    cardData: [{ name: '김염미', img: 'ps_Kim' }],
  },
  // {
  //   title: '협동 강도사',
  //   cardData: [{ name: '박재옥', img: 'ps_Park' }],
  // },
  {
    title: '전도사',
    cardData: [
      { name: '정옥경', img: 'ps_Jeong' },
      // { name: '전용배',  img: 'ps_Jeon'  },
    ],
  },
  {
    title: '은퇴 전도사',
    cardData: [{ name: '오순자', img: 'ps_Oh' }],
  },
];
